import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface IGenericDialog {
  message?: string;
  title?: string;
  buttons?: {
    primaryText?: string;
    primaryColor?: string;
    secondaryText?: string;
    secondaryColor?: string;
  };
}

@Component({
  selector: 'app-content-dialog-generic',
  templateUrl: './content-dialog-generic.component.html',
  styleUrls: ['./content-dialog-generic.component.sass'],
})
export class ContentDialogGenericComponent {
  sanitizedMessage: SafeHtml;

  constructor(
    private dialogRef: MatDialogRef<ContentDialogGenericComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IGenericDialog,
    private sanitizer: DomSanitizer
  ) {
    this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
    if (!this.data.buttons) {
      this.data.buttons = {};
    }
  }

  save() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}
